import { Pipe, PipeTransform } from '@angular/core';
import { Router } from '@angular/router';

@Pipe({
  name: 'urlNewTab'
})
export class UrlNewTabPipe implements PipeTransform {

  constructor(private router: Router) { }

  transform(value: string): unknown {

    return this.router.serializeUrl(this.router.createUrlTree([value]));
  }

}
